import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/MosquitoNet.module.scss'

import { Container, Image } from 'react-bootstrap'

import SimleForm from './SimleForm'

class MosquitoNet extends React.Component {

  render() {

    const { assets_path, data, dark_bg, dark_bg_mob } = this.props

    return (
      <section className={styles.section}>
        {dark_bg != '' &&
          <>
            <Image className={styles.section_bg} src={dark_bg} width={1920} height={299} alt={`Фон`} />
            <Image className={styles.section_bg_mob} src={dark_bg_mob} width={375} height={482} alt={`Фон моб.`} />
          </>
        }
        <div className={styles.section_content}>
          <Container>
            <h2 className={styles.title} dangerouslySetInnerHTML={{__html: data?.title}} />
            <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text}} />
          </Container>
          <div className={styles.sep}></div>
          <Container>
            <SimleForm
              btn={`Использовать акцию`}
              assets_path={assets_path}
              width={195}
              svg={(
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.4814 6.25L2.48145 6.25L2.48145 11.25C2.48145 13.125 3.10645 13.75 4.98145 13.75H9.98145C11.8564 13.75 12.4814 13.125 12.4814 11.25V6.25Z" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13.4375 4.375V5C13.4375 5.6875 13.1063 6.25 12.1875 6.25H2.8125C1.85625 6.25 1.5625 5.6875 1.5625 5V4.375C1.5625 3.6875 1.85625 3.125 2.8125 3.125L12.1875 3.125C13.1063 3.125 13.4375 3.6875 13.4375 4.375Z" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7.27474 3.12539H3.82474C3.61224 2.89414 3.61849 2.53789 3.84349 2.31289L4.73099 1.42539C4.96224 1.19414 5.34349 1.19414 5.57474 1.42539L7.27474 3.12539Z" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M11.1688 3.12539H7.71875L9.41875 1.42539C9.65 1.19414 10.0312 1.19414 10.2625 1.42539L11.15 2.31289C11.375 2.53789 11.3813 2.89414 11.1688 3.12539Z" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M5.58789 6.25V9.4625C5.58789 9.9625 6.13789 10.2562 6.55664 9.9875L7.14414 9.6C7.35664 9.4625 7.62539 9.4625 7.83164 9.6L8.38789 9.975C8.80039 10.25 9.35664 9.95625 9.35664 9.45625V6.25H5.58789Z" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            />
            {data?.image != '' &&
              <div className={styles.section_image_container}>
                <Image className={styles.section_image} src={data?.image} alt={`${data?.title} - фото`} width={454} height={276} />
                <Image className={styles.section_image_mob} src={data?.image_mob} alt={`${data?.title} - фото моб.`} width={375} height={253} />
              </div>
            }
          </Container>
        </div>
      </section>
    )
  }
}

MosquitoNet.propTypes = {
  data: PropTypes.object,
  assets_path: PropTypes.string,
  dark_bg: PropTypes.string,
  dark_bg_mob: PropTypes.string
}

MosquitoNet.defaultProps = {
  data: {},
  assets_path: 'assets',
  dark_bg: '',
  dark_bg_mob: ''
}

export default MosquitoNet